import { getJson } from './http';
import type { PayrollOverview } from '../../views/CompanyDashboard/types';

export async function fetchPayrollOverview(params: { from?: string; to?: string; scope?: 'personal' | 'team' | 'company' }, signal?: AbortSignal): Promise<PayrollOverview> {
  return await getJson<PayrollOverview>('/payroll/overview', params, signal);
}
